import { css } from '@emotion/react';
import { colors } from '../../global';

export const ButtonFormueBoxed = css`
    width: auto;
    border: 2px solid ${colors.white};
    color: ${colors.white};
    border-radius: 54px;
    background: transparent;
    font-size: 1em;
`;
